import App from "./App.svelte";
import { mount } from "svelte";
import { Amplify } from "aws-amplify";
import { Passwordless } from "amazon-cognito-passwordless-auth";
import { resolveConfig } from "../config";
import { webLibraryOptions, toPasswordlessConfig } from "../authentication";

const config = await resolveConfig();
Passwordless.configure(toPasswordlessConfig(config));

Amplify.configure(config, {
  Auth: {
    tokenProvider: webLibraryOptions.Auth?.tokenProvider,
  },
});
const app = mount(App, {
  target: document.body,
  props: {
    config,
  },
});
export default app;
